import {
    formatRouteFinder,
    RouteFinder,
} from "../../../shared/RouteLink/Route";

export const mkLink = ({ map = {}, ...route }: RouteFinder) =>
    formatRouteFinder({ ...route, map });
